import { Modal } from '@pankod/refine-antd';

interface CustomModalProps {
  title: string;
  isModalVisible: boolean;
  onOk: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
  onCancel: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
}

export const CustomModal: React.FC<CustomModalProps> = (props) => {
  return (
    <Modal
      title={props.title}
      visible={props.isModalVisible}
      onOk={props.onOk}
      onCancel={props.onCancel}
    >
      {props.children}
    </Modal>
  );
};
